import axios from 'axios'

const BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const baseConfig = {
    baseURL: BASE_URL,
    headers: { 
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
     },
}

export const ApiClient = axios.create(baseConfig)

function requestInterceptionHandler(config) {
    const accessToken = localStorage.getItem('assessmentai-token');

    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
    }
    return config
}

async function responseFailureInterceptionHandler(error) {
    // if (!error.response || error.response.status === 500) {
    //     return window.history.push && window.history.push('/not-found')
    // }
    if (!error.response || error.response.status === 401) {
        await localStorage.removeItem('assessmentai-token');
    }
    return Promise.reject(error)
}


ApiClient.interceptors.request.use(requestInterceptionHandler, (error) =>
    Promise.reject(error),
)

ApiClient.interceptors.response.use(
    (res) => res,
    responseFailureInterceptionHandler,
)
